import { GetBuyerSellerDirectoryResponse } from '@iwoca/lapi-client/iwocapay';

export type Seller = GetBuyerSellerDirectoryResponse['data']['sellers'][number];

export const TERM_SHORT_LABELS: Record<string, string> = {
  PAY_IN_30D: '30d',
  PAY_IN_3M: '3m',
  PAY_IN_12M: '12m',
};

export const TERM_LENGTH_LABELS: Record<string, string> = {
  PAY_IN_30D: '30 days',
  PAY_IN_3M: '3 months',
  PAY_IN_12M: '12 months',
};

export const PRICING_TYPE_LABELS: Record<string, string> = {
  INTEREST_FREE: 'Interest-free',
  INTEREST_BEARING: 'Interest-bearing',
};
